import {ModuleWithProviders, NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {DialogModule} from 'primeng/dialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DotNotationExtractorPipe} from './dot-notation-extractor.pipe';
import {ClickOutsideDirective} from './click-outside.directive';
import {CommonModule} from '@angular/common';
import {MatLegacySnackBarModule as MatSnackBarModule} from '@angular/material/legacy-snack-bar';
import {MainContentWrapperComponent} from '../main-temp/main-content-wrapper/main-content-wrapper.component';
import {UserService} from './services/user.service';
import {UserApiService} from '../../../projects/api/src/user/user-api.service';
import {LocaleService} from './services/locale.service';
import {ThemeService} from './services/theme.service';
import {IsAuthorizedService} from './services/is-authorized.service';
import {AuthService} from './services/auth.service';
import {AuthGuard} from './auth.guard';
import {ThemePickerComponent} from './header/theme-picker/theme-picker.component';
import {LocalizationPickerComponent} from './header/localization-picker/localization-picker.component';
import {LogoutComponent} from './header/user-menu/logout/logout.component';
import {HeaderNotificationsComponent} from './header/header-notifications/header-notifications.component';
import {HeaderComponent} from './header/header.component';
import {UserMenuComponent} from './header/user-menu/user-menu.component';
import {HeaderNotificationsService} from './header/header-notifications/header-notifications.service';
import {UserMenuService} from './header/user-menu/user-menu.service';
import {RouterModule} from '@angular/router';
import {LoadingIndicatorComponent} from './components/loading-indicator/loading-indicator.component';
import {PanelComponent} from './components/panel/panel.component';
import {DefaultDashboardService} from './services/default-dashboard.service';
import {DefaultStateService} from './services/default-state.service';
import {FileSaverProvider} from './FileSaverProvider';
import {DashboardSelectComponent} from './forms/fields/dashboard-select/dashboard-select.component';
import {PasswordInputComponent} from './forms/fields/password-input/password-input.component';
import {TextInputComponent} from './forms/fields/text-input/text-input.component';
import {SpinnerComponent} from './spinner/spinner.component';
import {FavoriteLinksComponent} from './header/favorite-links/favorite-links.component';
import {FavoriteLinkComponent} from './header/favorite-links/favorite-link/favorite-link.component';
import {StarIconComponent} from './header/favorite-links/star-icon/star-icon.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {BreadcrumbService} from './services/breadcrumb.service';
// import {InsparkComponentsModule, PipesModule} from '@inspark/inspark-components';
import {ScheduleApiService} from '../../../projects/api/src/schedule/schedule.service';
import {BreadCrumbsComponent} from './components/breadcrumbs/breadcrumbs.component';
import {HeaderLogoComponent} from './components/header-logo/header-logo.component';
import {NotificationService} from '../API/notification.service';
import {EventLogApiService} from '../../../projects/api/src/event-log/event-log-api.service';
import {DottedBorderTooltipComponent} from './dotted-border-tooltip/dotted-border-tooltip.component';
import {CookieService} from 'ng2-cookies';
import {FavoritesApiService} from '../../../projects/api/src/favorite/favorites-api.service';
import {FavoriteDialogComponent} from './header/favorite-links/favorite-dialog/favorite-dialog.component';
import {BorderTooltipComponent} from './border-tooltip/border-tooltip.component';
import {TruncatePipe} from './pipes/truncate';
import {HighlightedPipe} from './pipes/highlighted';
import {ApplicationPickerComponent} from './header/application-picker/application-picker.component';
import {CalendarModule} from 'primeng/calendar';
import {EventsInfoComponent} from './user-info/user-info.component';
import {ParamListFilterComponent} from './filter/filter.component';
import {StateCircleComponent} from './state-circle/state-circle.component';
import {ObjectPieTooltipComponent} from './pie-with-tooltip/pie-tooltip.component';
import {ObjectPieComponent} from './pie/pie.component';
import {FilterPipeModule} from 'ngx-filter-pipe';
import {TypeCircleComponent} from './state-circle/type-circle/type-circle.component';
import {InlineSVGModule} from 'ng-inline-svg';
import {ToastModule} from 'primeng/toast';
import {HeaderNotificationToastComponent} from './header/header-notification-toast/header-notification-toast.component';
import {EventComponent} from './components/event/event.component';
import { AboutAppComponent } from './header/user-menu/about-app/about-app.component';
import {WindowManagerComponent} from './window-manager/window-container/main.component';
import {WindowService} from './window-manager/window.service';
import {CallIconComponent} from './header/sip/call-icon/call-icon.component';
import {SipHeaderService} from './header/sip/sip-header.service';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {WindowComponent} from './window-manager/window/window.component';
import {InsparkUIModule} from '../inspark.module';
import {PipesModule} from './pipes/pipes.module';


@NgModule({
    imports: [
        TextInputComponent,
        NgbModule,
        RouterModule,
        CommonModule,
        TranslateModule.forChild(),
        CalendarModule,
        DialogModule,
        FormsModule,
        MatSnackBarModule,
        ReactiveFormsModule,
        InsparkUIModule,
        FilterPipeModule,
        InlineSVGModule,
        BreadCrumbsComponent,
        HeaderLogoComponent,
        SpinnerComponent,
        PanelComponent,
        LogoutComponent,
        LocalizationPickerComponent,
        LoadingIndicatorComponent,
        PasswordInputComponent,
        EventsInfoComponent,
        ClickOutsideDirective,
        ToastModule,
        EventComponent,
    ],
  declarations: [
    DotNotationExtractorPipe,
    HeaderComponent,
    UserMenuComponent,
    HeaderNotificationsComponent,
    HeaderNotificationToastComponent,
    ApplicationPickerComponent,
    ThemePickerComponent,
    MainContentWrapperComponent,
    StateCircleComponent,
    TypeCircleComponent,
    DashboardSelectComponent,
    FavoriteLinksComponent,
    FavoriteLinkComponent,
    StarIconComponent,
    CallIconComponent,
    FavoriteDialogComponent,
    TruncatePipe,
    HighlightedPipe,
    ParamListFilterComponent,
    BorderTooltipComponent,
    DottedBorderTooltipComponent,
    ObjectPieTooltipComponent,
    ObjectPieComponent,
    MainContentWrapperComponent,
    AboutAppComponent,
    WindowManagerComponent,
    WindowComponent,
  ],
  exports: [
    NgbModule,
    InsparkUIModule,
    TranslateModule,
    StateCircleComponent,
    ObjectPieTooltipComponent,

    CalendarModule,
    DialogModule,
    FavoriteDialogComponent,
    FormsModule,
    DotNotationExtractorPipe,
    MatSnackBarModule,
    HeaderComponent,
    UserMenuComponent,
    HeaderNotificationsComponent,
    HeaderNotificationToastComponent,
    LogoutComponent,
    LocalizationPickerComponent,
    ApplicationPickerComponent,
    ThemePickerComponent,
    MainContentWrapperComponent,
    LoadingIndicatorComponent,
    PanelComponent,
    DashboardSelectComponent,
    PasswordInputComponent,
    SpinnerComponent,
    TruncatePipe,
    HighlightedPipe,
    ParamListFilterComponent,
    BorderTooltipComponent,
    EventsInfoComponent,
    PipesModule,
    BreadCrumbsComponent,
    HeaderLogoComponent,
    DottedBorderTooltipComponent,
    ClickOutsideDirective,
    ObjectPieComponent,
    WindowManagerComponent,
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        AuthGuard,
        AuthService,
        UserService,
        UserMenuService,
        HeaderNotificationsService,
        LocaleService,
        ThemeService,
        UserApiService,
        IsAuthorizedService,
        DefaultDashboardService,
        DefaultStateService,
        FileSaverProvider,
        BreadcrumbService,
        ScheduleApiService,
        NotificationService,
        EventLogApiService,
        CookieService,
        FavoritesApiService,
        WindowService,
        SipHeaderService,
        DynamicDialogRef,
        DynamicDialogConfig,
      ]
    };
  }
}
